import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Text, Input } from 'wix-style-react'
import copy from 'copy-to-clipboard'

import Phone from '../../shared/Phone'
import { getTemplateInfo } from '../../../templates/templates'
import { applyCustomFields, publish } from 'controllers/logic'
import instaBioExample from '../../../assets/instaBioExample.png'
import { IA_HOST_NAME } from '../../../constants'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #eff4f7;
  display: flex;
  justify-content: center;
`
const MainContainer = styled.div`
  width: 50%;
  height: 100%;
  margin-left: 3%;
  margin-right: 3%;
  display: flex;
  padding-top: 2em;
  padding-bottom: 2em;
  flex-direction: row;
`
const PhoneContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`
const InfoContainer = styled.div`
  width: 40em;
  height: 100%;
  border-radius: 18px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(204, 204, 204, 0.5);
  flex: 1;
  display: flex;
  flex-direction: column;
`
const InfoHeader = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 3em;
  border-bottom: solid 0.5px #e3e0e0;
`
const InfoBody = styled.div`
  flex: 8;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Description = styled.div`
  text-align: center;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`
const InputContainer = styled.div`
  margin-top: 1em;
  text-align: center;
  flex: 0.5;
  width: 90%;
`
const InstaExampleContainer = styled.div`
  text-align: center;
  flex: 5;
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Image = styled.img`
  max-width: 80%;
  max-height: 80%;
  vertical-align: middle;
`
const InputSuffixContainer = styled.div`
  text-align: center;
  width: 5em;
  border-left: solid 0.5px #c1e4fe;
  cursor: pointer;
`

class InstaAppPreview extends Component {

  componentDidMount () {
    const { dispatch, app } = this.props
    dispatch(publish(app))
  }

  getInstantAppOfApplication = () => {
    const { app } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    const settings = applyCustomFields(app.customFields, templateInfo.defaultSettings)
    return <templateInfo.instantApp settings={settings} showcaseMode />
  }

  copyLink = (e) => {
    const { app } = this.props
    e.preventDefault()
    copy(`${IA_HOST_NAME}/${app.name}`)
  }

  renderCopyLinkButton () {
    return (
      <InputSuffixContainer onClick={this.copyLink}>
        <Text appearance='T1.3'>Copy link</Text>
      </InputSuffixContainer>
    )
  }

  render () {
    const { app } = this.props
    return (
      <Wrapper>
        <MainContainer>
          <PhoneContainer>
            <Phone>
              {this.getInstantAppOfApplication()}
            </Phone>
          </PhoneContainer>
          <InfoContainer>
            <InfoHeader>
              <Text appearance='H2'>How to make your Instagram shop Live</Text>
            </InfoHeader>
            <InfoBody>
              <Description>
                <Text appearance='T4.1'>Its simple!  Just replace your Instagram bio link with this url:</Text>
              </Description>
              <InputContainer>
                <Input
                  roundInput
                  readOnly
                  value={`${IA_HOST_NAME}/${app.name}`}
                  suffix={this.renderCopyLinkButton()}
                />
              </InputContainer>
              <InstaExampleContainer>
                <Image src={instaBioExample} />
              </InstaExampleContainer>
            </InfoBody>
          </InfoContainer>
        </MainContainer>
      </Wrapper>
    )
  }
}

InstaAppPreview.propTypes = {
  app: PropTypes.object.isRequired
}


export default connect()(InstaAppPreview)



// WEBPACK FOOTER //
// ./src/components/editor/insta/InstaAppPreview.js